module.exports = __webpack_public_path__ + "static/img/04.23241db0.png";